/**
 * Changes made:
 * - 2025-09-28: Created HeroTextContent component with heading and subtitle for hero section
 * - 2025-10-01: Added mobile optimization with responsive typography and layout
 * - 2025-10-02: Split description text into two lines after "darmowa." for improved readability
 * - 2025-10-03: Added tablet support with isTablet prop for iPad-optimized text sizing (between mobile and desktop)
 * - 2025-10-07: Adjusted desktop version spacing from gap-8 to gap-6 to match paragraph spacing consistency
 * - 2025-10-07: Reduced spacing between paragraph lines in desktop version from double to single line break
 * - 2025-11-06: Changed "Sprzedaż samochodu online!" from div to h1 tag for proper SEO
 */

interface HeroTextContentProps {
  isMobile?: boolean;
  isTablet?: boolean;
}

export const HeroTextContent = ({ isMobile = false, isTablet = false }: HeroTextContentProps) => {
  if (isMobile) {
    return (
      <div data-layer="Text Container" className="TextContainer w-full flex flex-col justify-start items-start gap-4">
        <h1 data-layer="Title" className="Title self-stretch justify-start text-white text-3xl font-heebo font-extrabold leading-tight tracking-tight" style={{ fontWeight: 800 }}>
          Sprzedaż samochodu online!
        </h1>
      <div data-layer="Description" className="Description self-stretch justify-start text-white text-base font-heebo font-medium tracking-tight" style={{ fontWeight: 500 }}>
        Sprzedaż na Autaro.pl jest szybka, bezpieczna i całkowicie darmowa.
        <br />
        <br />
        Podaj VIN, przebieg i skrzynie biegów i zobaczysz wstępne informacje cenowe. Po uzupełnieniu profilu twój samochód jest dostępny dla naszej sieci komisów i skupów, którzy są zainteresowani twoim samochodem.
        <br />
        <br />
        Alternatywa dla skupu aut — zamiast jednej oferty, konkurencja między komisami z całej Polski.
      </div>
      </div>
    );
  }

  if (isTablet) {
    return (
      <div data-layer="Text" className="Text w-full max-w-[500px] flex flex-col justify-start items-start gap-4">
        <h1 data-layer="Heading" className="Heading self-stretch text-white text-4xl font-heebo font-extrabold" style={{ fontWeight: 800 }}>
          Sprzedaż samochodu online!
        </h1>
        <div data-layer="Description" className="Description self-stretch text-neutral-50 text-xl font-heebo font-medium tracking-tight text-left" style={{ fontWeight: 500 }}>
          Sprzedaż na Autaro.pl jest szybka, bezpieczna i całkowicie darmowa.
          <br />
          <br />
          Podaj VIN, przebieg i skrzynie biegów i zobaczysz wstępne informacje cenowe. Po uzupełnieniu profilu twój samochód jest dostępny dla naszej sieci komisów i skupów, którzy są zainteresowani twoim samochodem.
          <br />
          <br />
          Alternatywa dla skupu aut — zamiast jednej oferty, konkurencja między komisami z całej Polski.
        </div>
      </div>
    );
  }

  return (
    <div data-layer="Text Container" className="TextContainer w-[574px] inline-flex flex-col justify-start items-start gap-6">
      <h1 data-layer="Title" className="Title self-stretch justify-start text-neutral-50 text-6xl font-heebo font-extrabold leading-[90px] tracking-tight" style={{ fontWeight: 800 }}>
        Sprzedaż samochodu online!
      </h1>
      <div data-layer="Description" className="Description self-stretch justify-start text-neutral-50 text-xl font-heebo font-medium tracking-tight" style={{ fontWeight: 500 }}>
        Sprzedaż na Autaro.pl jest szybka, bezpieczna i całkowicie darmowa. Podaj VIN, przebieg i skrzynie biegów i zobaczysz wstępne informacje cenowe. Po uzupełnieniu profilu twój samochód jest dostępny dla naszej sieci komisów i skupów, którzy są zainteresowani twoim samochodem.
        <br />
        <br />
        Alternatywa dla skupu aut — zamiast jednej oferty, konkurencja między komisami z całej Polski.
      </div>
    </div>
  );
};